
// import { Icon } from "@iconify/react";
// import { Link } from "react-router-dom";
// import React, { useState, useEffect, useRef } from "react";
// import Featurelist from "../Feature/FeatureProductlist/Featurelist";
// import sizeChart from "../../../assets/images/sizechart.jpeg";

// // Define base URL and static size chart URLs for fallback
// const SERVER_BASE_URL = "https://admin.monsinidress.com";

// // Default data structure
// const defaultData = {
// 	PROM: {
// 		years: [2027, 2026, 2025],
// 		sizeChartImage: sizeChart,
// 	},
// };

// // Helper function to construct full image URL
// const constructImageUrl = (imagePath) => {
// 	if (!imagePath) return null;

// 	// If it's already a full URL, use it directly
// 	if (imagePath.startsWith("http")) {
// 		return imagePath;
// 	}

// 	// If it starts with a slash, remove it to avoid double slashes
// 	const cleanPath = imagePath.startsWith("/")
// 		? imagePath.substring(1)
// 		: imagePath;

// 	// Construct full URL
// 	return `${SERVER_BASE_URL}/${cleanPath}`;
// };

// // --- Dropdown Menu Component ---
// const DropdownMenu = ({ title, options, onSizeChartClick }) => {
// 	return (
// 		<li className="relative group font-poppins font-medium text-[15px]">
// 			<span className="flex items-center cursor-pointer py-2 px-3 text-black font-medium hover:text-[#1f4c94] transition-colors duration-200 uppercase tracking-wide">
// 				{title}
// 				<Icon
// 					icon="heroicons:chevron-down-20-solid"
// 					className="ml-1 h-4 w-4 transition-transform group-hover:rotate-180"
// 				/>
// 			</span>

// 			{/* Dropdown Content */}
// 			<div className="absolute left-1/2 -translate-x-1/2 mt-0 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-40 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 ease-in-out">
// 				<div className="py-1">
// 					{options.map((option, index) =>
// 						option.label === "Size Chart" ? (
// 							<button
// 								key={index}
// 								onClick={() => onSizeChartClick(title)}
// 								className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1f4c94] w-full text-center border-b border-gray-100 last:border-b-0 transition-colors duration-200">
// 								{option.label}
// 							</button>
// 						) : (
// 							<Link
// 								key={index}
// 								to={option.value}
// 								className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1f4c94] w-full text-center border-b border-gray-100 last:border-b-0 transition-colors duration-200">
// 								{option.label}
// 							</Link>
// 						)
// 					)}
// 				</div>
// 			</div>
// 		</li>
// 	);
// };

// // --- Navbar Component ---
// export default function Navbar() {
// 	const [isScrolled, setIsScrolled] = useState(false);
// 	const [showSearch, setShowSearch] = useState(false);
// 	const [showMenu, setShowMenu] = useState(false);
// 	const [showSizeChart, setShowSizeChart] = useState("");
// 	const [zoomed, setZoomed] = useState(false);
// 	const [isZoomActive, setIsZoomActive] = useState(false);
// 	const [zoomPosition, setZoomPosition] = useState({ x: 50, y: 50 });
// 	const imageRef = useRef(null);
// 	const [data, setdata] = useState([]);
// 	const [apiData, setApiData] = useState(defaultData);

// 	// First API call (for search data)
// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				const apiUrl = `${SERVER_BASE_URL}/api/products/brand`;
// 				const response = await fetch(apiUrl, {
// 					method: "POST",
// 					headers: {
// 						"Content-Type": "application/json",
// 					},
// 					body: JSON.stringify({ brand: "Azure" }),
// 				});

// 				if (!response.ok) {
// 					throw new Error(`HTTP error! status: ${response.status}`);
// 				}

// 				const data = await response.json();
// 				setdata(data.data.products);
// 			} catch (error) {
// 				console.error("Error fetching data:", error);
// 			}
// 		};

// 		fetchData();
// 	}, []);

// 	// NEW API call (for navigation categories and size charts)
// 	useEffect(() => {
// 		const fetchProducts = async () => {
// 			try {
// 				const response = await fetch(
// 					`https://admin.monsinidress.com/api/navbar`,
// 					{
// 						method: "POST",
// 						headers: { "Content-Type": "application/json" },
// 						body: JSON.stringify({ brand: "Azure" }),
// 					}
// 				);

// 				if (!response.ok) {
// 					throw new Error("Failed to fetch products");
// 				}

// 				const productsData = await response.json();
// 				console.log("Fetched products data:", productsData);

// 				if (productsData.data && Object.keys(productsData.data).length > 0) {
// 					// Transform the API data to match our expected structure
// 					const transformedData = {};

// 					// Handle Prom data (from data.Prom)
// 					if (productsData.data.Prom) {
// 						const sizeChartImage =
// 							constructImageUrl(productsData.data.Prom.sizeChartImage) ||
// 							sizeChart;

// 						transformedData.PROM = {
// 							years: productsData.data.Prom.years || [],
// 							sizeChartImage: sizeChartImage,
// 						};
// 					}

// 					// Handle other categories if provided by API

// 					// Merge with default data for other categories
// 					const mergedData = {
// 						...defaultData,
// 						...transformedData,
// 					};

// 					setApiData(mergedData);
// 				} else {
// 					// Fallback to default data if API response is empty
// 					setApiData(defaultData);
// 				}
// 			} catch (error) {
// 				console.error("Error fetching products:", error);
// 				setApiData(defaultData);
// 			}
// 		};

// 		fetchProducts();
// 	}, []);

// 	// Scroll effect
// 	useEffect(() => {
// 		const handleScroll = () => setIsScrolled(window.scrollY > 50);
// 		window.addEventListener("scroll", handleScroll);
// 		return () => window.removeEventListener("scroll", handleScroll);
// 	}, []);

// 	// Helper to get the size chart image URL
// 	const getSizeChartImage = (categoryKey) => {
// 		const categoryData = apiData[categoryKey];

// 		if (categoryData && categoryData.sizeChartImage) {
// 			return categoryData.sizeChartImage;
// 		}

// 		// Fallback to default images
// 		switch (categoryKey) {
// 			case "PROM":
// 				return sizeChart;

// 			default:
// 				return sizeChart;
// 		}
// 	};

// 	// Prepare Prom options
// 	const promCategory = apiData["PROM"] || { years: [] };
// 	const sortedPromYears = [...promCategory.years].sort((a, b) => b - a);
// 	const promOptions = [
// 		...sortedPromYears.map((year) => ({
// 			label: `${year} Collection`,
// 			value: `/prom/${year}`,
// 		})),
// 		{ label: "Size Chart", value: "sizeChart" },
// 	];

// 	// Function to handle size chart clicks
// 	const handleSizeChartClick = (category) => {
// 		setShowSizeChart(category.toUpperCase());
// 	};

// 	// Zoom effect handlers
// 	const handleMouseMove = (e) => {
// 		if (!imageRef.current) return;

// 		const rect = imageRef.current.getBoundingClientRect();
// 		const x = (e.nativeEvent.offsetX / rect.width) * 100;
// 		const y = (e.nativeEvent.offsetY / rect.height) * 100;
// 		setZoomPosition({ x, y });
// 	};

// 	const handleMouseEnter = () => {
// 		setIsZoomActive(true);
// 	};

// 	const handleMouseLeave = () => {
// 		setIsZoomActive(false);
// 	};

// 	// Get the image source for the currently selected size chart category
// 	const sizeChartImageSrc = getSizeChartImage(showSizeChart);

// 	return (
// 		<>
// 			{/* Size Chart Modal */}
// 			{showSizeChart && (
// 				<div className="fixed inset-0 h-screen bg-black bg-opacity-70 flex items-center justify-center z-[10000] p-4">
// 					<div className="absolute top-4 right-4 gap-3 z-10 flex justify-between items-center">
// 						<button
// 							onClick={() => setZoomed((prev) => !prev)}
// 							className="bg-white/10 hover:bg-white/20 text-white p-2 rounded-full transition">
// 							<Icon
// 								icon={
// 									zoomed
// 										? "mdi:magnify-minus-outline"
// 										: "mdi:magnify-plus-outline"
// 								}
// 								className="w-7 h-7"
// 							/>
// 						</button>

// 						<button
// 							onClick={() => {
// 								setShowSizeChart("");
// 								setZoomed(false);
// 								setIsZoomActive(false);
// 							}}
// 							className="bg-white/10 hover:bg-white/20 text-white p-2 rounded-full transition">
// 							<Icon icon="heroicons:x-mark-20-solid" className="w-7 h-7" />
// 						</button>
// 					</div>
// 					<div className="w-full bg-transparent flex flex-col justify-center items-center gap-5 relative">
// 						<div
// 							className={`w-[100%] h-full max-h-[90vh] overflow-x-auto overflow-y-hidden flex justify-center ${
// 								zoomed ? "cursor-grab" : ""
// 							}`}>
// 							<div
// 								ref={imageRef}
// 								className="w-[70%] max-h-[600px] relative overflow-hidden rounded-2xl bg-gray-50"
// 								onMouseMove={handleMouseMove}
// 								onMouseEnter={handleMouseEnter}
// 								onMouseLeave={handleMouseLeave}>
// 								<img
// 									src={sizeChartImageSrc}
// 									alt={`${showSizeChart} Size Chart`}
// 									className={`transition-transform duration-300 w-full h-full object-contain px-5 ${
// 										zoomed ? "scale-110" : "scale-100"
// 									}`}
// 									style={{
// 										transformOrigin: "center center",
// 										minWidth: zoomed ? "130%" : "auto",
// 									}}
// 								/>

// 								<div
// 									className="absolute inset-0 transition-opacity duration-300"
// 									style={{
// 										opacity: isZoomActive && !zoomed ? 1 : 0,
// 										backgroundImage: `url(${sizeChartImageSrc})`,
// 										backgroundSize: "200%",
// 										backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
// 										pointerEvents: "none",
// 									}}
// 								/>
// 								<div
// 									className={`absolute bottom-4 right-4 bg-blue-600 text-white w-[50px] flex items-center justify-center px-0 py-[14px] rounded-full text-sm transition-all duration-300 ${
// 										isZoomActive && !zoomed ? "opacity-100" : "opacity-0"
// 									}`}>
// 									<Icon icon="iconamoon:zoom-in-light" width="20" height="20" />
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			)}

// 			{/* Navbar */}
// 			<div
// 				className={`fixed left-0 w-full z-50 transition-all duration-500 ${
// 					isScrolled ? "top-[-52px]" : "top-0"
// 				}`}>
// 				{/* Top Black Bar */}
// 				<div
// 					className={`flex md:justify-between justify-center items-center bg-[#1f4c94] w-full px-5 py-3 transition-all duration-500 ${
// 						isScrolled
// 							? "opacity-0 pointer-events-none -translate-y-4 scale-95"
// 							: "opacity-100 translate-y-0 scale-100"
// 					}`}>
// 					<Link
// 						to="https://www.instagram.com/azuredress?igsh=MXhoNzZ2N3hqbjgyeA=="
// 						target="_blank">
// 						<Icon
// 							icon="ri:instagram-fill"
// 							width="22"
// 							height="22"
// 							className="text-white hover:text-gray-300 transition"
// 						/>
// 					</Link>

// 					<div className="hidden md:flex items-center gap-3">
// 						<button onClick={() => setShowSearch(true)}>
// 							<Icon icon="bx:search-alt" width="24" height="24" color="white" />
// 						</button>
// 					</div>
// 				</div>

// 				{/* Main Navigation */}
// 				<div
// 					className={`bg-white transition-all duration-500 ease-in-out border-b border-gray-100 ${
// 						isScrolled ? "shadow-lg py-5" : "py-6"
// 					}`}>
// 					<div className="flex md:justify-center justify-between items-center px-4">
// 						<div className="block md:hidden" onClick={() => setShowMenu(true)}>
// 							<Icon icon="hugeicons:menu-09" width="35" height="35" />
// 						</div>
// 						<div className="cursor-pointer font-americana font-extrabold text-center">
// 							<h2 className="text-4xl bg-gradient-to-r from-[#3A7BD5] via-[#8A2BE2] to-[#00D2FF] bg-clip-text text-transparent">
// 								Azure
// 							</h2>
// 							<span className="text-[10px] uppercase tracking-[3px] text-gray-600 mt-2 block group-hover:text-[#3A7BD5] transition-colors">
// 								Proudly Canadian
// 							</span>
// 						</div>

// 						<div className="flex items-center gap-3 md:hidden">
// 							<button onClick={() => setShowSearch(true)}>
// 								<Icon
// 									icon="bx:search-alt"
// 									width="24"
// 									height="24"
// 									color="black"
// 								/>
// 							</button>
// 						</div>
// 					</div>

// 					{/* Navigation Menu */}
// 					<div className="pt-3 pb-3 hidden md:block">
// 						<ul className="hidden md:flex font-poppins justify-center items-center gap-8 flex-wrap">
// 							<li>
// 								<Link
// 									to="/"
// 									className="text-black font-medium hover:text-[#1f4c94] py-2 px-3">
// 									HOME
// 								</Link>
// 							</li>

// 							{/* PROM Dropdown */}
// 							<DropdownMenu
// 								title="PROM"
// 								options={promOptions}
// 								onSizeChartClick={handleSizeChartClick}
// 							/>

// 							{/* BRIDAL Dropdown */}
// 							{apiData.BRIDAL && (
// 								<DropdownMenu
// 									title="BRIDAL"
// 									options={[
// 										...apiData.BRIDAL.years.map((year) => ({
// 											label: `${year} Collection`,
// 											value: `/bridal/${year}`,
// 										})),
// 										{ label: "Size Chart", value: "sizeChart" },
// 									]}
// 									onSizeChartClick={handleSizeChartClick}
// 								/>
// 							)}

// 							{/* EVENING Dropdown */}
// 							{apiData.EVENING && (
// 								<DropdownMenu
// 									title="EVENING"
// 									options={[
// 										...apiData.EVENING.years.map((year) => ({
// 											label: `${year} Collection`,
// 											value: `/evening/${year}`,
// 										})),
// 										{ label: "Size Chart", value: "sizeChart" },
// 									]}
// 									onSizeChartClick={handleSizeChartClick}
// 								/>
// 							)}

// 							<li>
// 								<Link
// 									to="/about"
// 									className="text-black font-medium hover:text-[#1f4c94] py-2 px-3">
// 									ABOUT US
// 								</Link>
// 							</li>
// 							<li>
// 								<Link
// 									to="/contact"
// 									className="text-black font-medium hover:text-[#1f4c94] py-2 px-3">
// 									CONTACT
// 								</Link>
// 							</li>
// 							<li className="border-[2px] border-[#1f4c94] p-2 rounded-md text-[#1f4c94] hover:bg-[#1f4c94] hover:text-white transition">
// 								<Link
// 									to="https://market.azuredress.com/"
// 									className="flex items-center gap-1 transition">
// 									<span className="text-sm font-semibold">RETAILER LOGIN</span>
// 								</Link>
// 							</li>
// 						</ul>
// 					</div>
// 				</div>
// 			</div>

// 			{/* Modals */}
// 			<SearchModal
// 				show={showSearch}
// 				onClose={() => setShowSearch(false)}
// 				data={data}
// 			/>
// 			<MenuModal
// 				show={showMenu}
// 				onClose={() => setShowMenu(false)}
// 				apiData={apiData}
// 			/>
// 		</>
// 	);
// }

// // --- SearchModal Component (Unchanged) ---
// function SearchModal({ show, onClose, data }) {
// 	const [searchTerm, setSearchTerm] = useState("");
// 	const filteredResults =
// 		searchTerm?.length >= 3
// 			? data?.filter((item) =>
// 					item.style?.toLowerCase()?.includes(searchTerm?.toLowerCase())
// 			  )
// 			: [];

// 	return (
// 		<div
// 			className={`fixed inset-0 bg-white z-[1000] flex flex-col items-center justify-start pt-20 transition-all duration-500 ease-in-out ${
// 				show ? "opacity-100 visible" : "opacity-0 invisible"
// 			}`}>
// 			<div className="absolute top-6 right-6">
// 				<button
// 					onClick={onClose}
// 					className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition">
// 					<Icon
// 						icon="system-uicons:cross"
// 						width="35"
// 						height="35"
// 						color="#000"
// 					/>
// 				</button>
// 			</div>

// 			{data?.length > 0 ? (
// 				<div className="w-[90%] md:w-[60%] lg:w-[40%] flex items-center gap-3 border-b-2 border-gray-400 pb-2 mb-6">
// 					<Icon icon="bx:search-alt" width="30" height="30" color="black" />
// 					<input
// 						type="text"
// 						value={searchTerm}
// 						onChange={(e) => setSearchTerm(e.target.value)}
// 						placeholder="Search here..."
// 						className="w-full outline-none text-lg font-medium"
// 					/>
// 				</div>
// 			) : (
// 				<p className="text-gray-500">Loading...</p>
// 			)}

// 			<div
// 				style={{
// 					scrollbarWidth: "thin",
// 					scrollbarColor: "#1f4c94",
// 				}}
// 				className="w-[90%] md:w-[70%] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 overflow-y-auto max-h-[80vh] pb-10">
// 				{filteredResults.length > 0 ? (
// 					filteredResults.map((item) => (
// 						<Featurelist key={item.id} data={item} />
// 					))
// 				) : searchTerm.length >= 3 ? (
// 					<p className="text-gray-500 text-center w-full">No results found.</p>
// 				) : (
// 					<p className="text-gray-400 text-center w-full">
// 						Type at least 3 letters to search
// 					</p>
// 				)}
// 			</div>
// 		</div>
// 	);
// }

// // --- MenuModal Component (Updated with helper function) ---
// function MenuModal({ show, onClose, apiData }) {
// 	// Use the same helper function
// 	const getSizeChartImage = (categoryKey) => {
// 		const categoryData = apiData[categoryKey];
// 		if (categoryData && categoryData.sizeChartImage) {
// 			return categoryData.sizeChartImage;
// 		}

// 		switch (categoryKey) {
// 			case "PROM":
// 				return sizeChart;

// 			default:
// 				return sizeChart;
// 		}
// 	};

// 	const [openDropdown, setOpenDropdown] = useState(null);
// 	const [showSizeChart, setShowSizeChart] = useState("");
// 	const [zoomed, setZoomed] = useState(false);
// 	const [isZoomActive, setIsZoomActive] = useState(false);
// 	const [zoomPosition, setZoomPosition] = useState({ x: 50, y: 50 });
// 	const imageRef = useRef(null);

// 	const toggleDropdown = (menuName) => {
// 		setOpenDropdown(openDropdown === menuName ? null : menuName);
// 	};

// 	const handleNavigate = (optionValue, categoryName) => {
// 		if (optionValue === "sizeChart") {
// 			setShowSizeChart(categoryName.toUpperCase());
// 		} else {
// 			onClose();
// 		}
// 	};

// 	const handleMouseMove = (e) => {
// 		if (!imageRef.current) return;
// 		const rect = imageRef.current.getBoundingClientRect();
// 		const x = ((e.clientX - rect.left) / rect.width) * 100;
// 		const y = ((e.clientY - rect.top) / rect.height) * 100;
// 		setZoomPosition({ x, y });
// 	};

// 	const handleMouseEnter = () => {
// 		setIsZoomActive(true);
// 	};

// 	const handleMouseLeave = () => {
// 		setIsZoomActive(false);
// 	};

// 	const sizeChartImageSrc = getSizeChartImage(showSizeChart);

// 	return (
// 		<>
// 			{/* Size Chart Modal */}
// 			{showSizeChart && (
// 				<div className="fixed inset-0 h-screen bg-black bg-opacity-70 flex items-center justify-center z-[1200] p-4">
// 					<button
// 						onClick={() => setShowSizeChart("")}
// 						className="absolute top-3 right-3 text-gray-200 hover:text-blue-600 transition z-10">
// 						<Icon icon="heroicons:x-mark-20-solid" className="w-7 h-7" />
// 					</button>

// 					<button
// 						onClick={() => setZoomed((prev) => !prev)}
// 						className="absolute top-3 left-3 text-gray-200 hover:text-blue-600 transition z-10">
// 						<Icon
// 							icon={
// 								zoomed
// 									? "mdi:magnify-minus-outline"
// 									: "mdi:magnify-plus-outline"
// 							}
// 							className="w-7 h-7"
// 						/>
// 					</button>

// 					<div className="bg-transparent w-full flex flex-col justify-center items-center gap-5 relative">
// 						<div
// 							className={`w-full h-full max-h-[90vh] overflow-auto flex justify-center items-start ${
// 								zoomed ? "cursor-grab" : ""
// 							}`}>
// 							<div
// 								ref={imageRef}
// 								className="relative overflow-hidden rounded-2xl bg-gray-50"
// 								onMouseMove={handleMouseMove}
// 								onMouseEnter={handleMouseEnter}
// 								onMouseLeave={handleMouseLeave}
// 								style={{
// 									width: zoomed ? "200%" : "100%",
// 									height: zoomed ? "auto" : "500px",
// 									transition: "all 0.3s ease",
// 								}}>
// 								<img
// 									src={sizeChartImageSrc}
// 									alt={`${showSizeChart} Size Chart`}
// 									className="w-full h-full object-contain"
// 								/>

// 								{!zoomed && (
// 									<div
// 										className="absolute inset-0 transition-opacity duration-300"
// 										style={{
// 											opacity: isZoomActive ? 1 : 0,
// 											backgroundImage: `url(${sizeChartImageSrc})`,
// 											backgroundSize: "200%",
// 											backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
// 											pointerEvents: "none",
// 										}}
// 									/>
// 								)}
// 							</div>

// 							<div
// 								className={`absolute bottom-4 right-4 bg-blue-600 text-white w-[50px] h-[50px] flex items-center justify-center rounded-full text-sm transition-all duration-300 ${
// 									isZoomActive && !zoomed ? "opacity-100" : "opacity-0"
// 								}`}>
// 								<Icon icon="iconamoon:zoom-in-light" width="20" height="20" />
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			)}

// 			{/* Main Menu Modal */}
// 			<div
// 				className={`fixed top-0 left-0 h-full w-[80%] md:w-[40%] bg-white shadow-2xl z-[1000] transition-transform duration-500 ease-in-out ${
// 					show ? "translate-x-0" : "-translate-x-full"
// 				}`}>
// 				<div className="flex justify-between items-center px-5 py-4 border-b">
// 					<h2 className="text-lg font-semibold">Menu</h2>
// 					<button
// 						onClick={onClose}
// 						className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition">
// 						<Icon icon="si:close-duotone" width="35" height="35" color="#000" />
// 					</button>
// 				</div>

// 				<ul className="flex flex-col gap-4 mt-5 px-4 font-poppins text-[16px] font-medium text-black">
// 					<li className="px-2">
// 						<Link to="/" onClick={onClose}>
// 							HOME
// 						</Link>
// 					</li>

// 					{/* Dynamic Categories */}
// 					{Object.keys(apiData).map((categoryName) => (
// 						<li className="px-2" key={categoryName}>
// 							<button
// 								onClick={() => toggleDropdown(categoryName.toLowerCase())}
// 								className="flex items-center gap-2 font-medium hover:text-[#1f4c94] w-full text-left">
// 								{categoryName}
// 								<Icon
// 									icon={
// 										openDropdown === categoryName.toLowerCase()
// 											? "akar-icons:chevron-up"
// 											: "akar-icons:chevron-down"
// 									}
// 								/>
// 							</button>
// 							{openDropdown === categoryName.toLowerCase() && (
// 								<ul className="ml-5 mt-2 flex flex-col gap-4">
// 									{apiData[categoryName].years
// 										.sort((a, b) => b - a)
// 										.map((year, index) => (
// 											<li
// 												key={index}
// 												className="hover:text-[#1f4c94] text-black">
// 												<Link
// 													to={`/${categoryName.toLowerCase()}/${year}`}
// 													onClick={onClose}>
// 													{`${year} Collection`}
// 												</Link>
// 											</li>
// 										))}
// 									<li className="hover:text-[#1f4c94] text-black">
// 										<button
// 											onClick={() => handleNavigate("sizeChart", categoryName)}
// 											className="w-full text-left hover:text-[#1f4c94]">
// 											Size Chart
// 										</button>
// 									</li>
// 								</ul>
// 							)}
// 						</li>
// 					))}

// 					<li className="px-2">
// 						<Link to="/about" onClick={onClose}>
// 							ABOUT US
// 						</Link>
// 					</li>
// 					<li className="px-2">
// 						<Link to="/contact" onClick={onClose}>
// 							CONTACT
// 						</Link>
// 					</li>
// 					<li>
// 						<Link
// 							to="https://market.azuredress.com/"
// 							className="flex items-center gap-1 bg-[#1f4c94] text-white px-2 py-3 hover:text-gray-300 transition"
// 							onClick={onClose}>
// 							<span className="font-medium">RETAILER LOGIN</span>
// 						</Link>
// 					</li>
// 				</ul>
// 			</div>
// 		</>
// 	);
// }








import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import Featurelist from "../Feature/FeatureProductlist/Featurelist";

/* =========================================================
   API
========================================================= */

const SERVER_BASE_URL = "https://admin.monsinidress.com";

/* =========================================================
   DEFAULT NAVBAR DATA
========================================================= */

const defaultData = {
	PROM: {
		years: [2027, 2026, 2025],
	},
};

/* =========================================================
   DROPDOWN
========================================================= */

const DropdownMenu = ({ title, options }) => {
	return (
		<li className="relative group font-poppins font-medium text-[15px]">
			<span className="flex items-center cursor-pointer py-2 px-3 text-black font-medium hover:text-[#1f4c94] transition-colors duration-200 uppercase tracking-wide">
				{title}

				<Icon
					icon="heroicons:chevron-down-20-solid"
					className="ml-1 h-4 w-4 transition-transform group-hover:rotate-180"
				/>
			</span>

			{/* Dropdown Content */}

			<div className="absolute left-1/2 -translate-x-1/2 mt-0 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-40 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 ease-in-out">
				<div className="py-1">
					{options.map((option, index) => (
						<Link
							key={`${option.label}-${index}`}
							to={option.value}
							className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1f4c94] w-full text-center border-b border-gray-100 last:border-b-0 transition-colors duration-200"
						>
							{option.label}
						</Link>
					))}
				</div>
			</div>
		</li>
	);
};

/* =========================================================
   NAVBAR
========================================================= */

export default function Navbar() {
	const navigate = useNavigate();

	/* =====================================================
	   STATE
	===================================================== */

	const [isScrolled, setIsScrolled] = useState(false);
	const [showSearch, setShowSearch] = useState(false);
	const [showMenu, setShowMenu] = useState(false);

	const [data, setData] = useState([]);
	const [apiData, setApiData] = useState(defaultData);

	/* =====================================================
	   FETCH AZURE PRODUCTS
	   SEARCH DATA
	===================================================== */

	useEffect(() => {
		const controller = new AbortController();

		const fetchData = async () => {
			try {
				const apiUrl = `${SERVER_BASE_URL}/api/products/brand`;

				const response = await fetch(apiUrl, {
					method: "POST",

					headers: {
						"Content-Type": "application/json",
					},

					body: JSON.stringify({
						brand: "Azure",
					}),

					signal: controller.signal,
				});

				if (!response.ok) {
					throw new Error(
						`Products API error: ${response.status}`
					);
				}

				const result = await response.json();

				console.log(
					"AZURE PRODUCT API:",
					result
				);

				const products =
					result?.data?.products || [];

				setData(
					Array.isArray(products)
						? products
						: []
				);
			} catch (error) {
				if (error.name === "AbortError") {
					return;
				}

				console.error(
					"Error fetching Azure products:",
					error
				);
			}
		};

		fetchData();

		return () => {
			controller.abort();
		};
	}, []);

	/* =====================================================
	   FETCH AZURE NAVBAR
	===================================================== */

	useEffect(() => {
		const controller = new AbortController();

		const fetchNavbarData = async () => {
			try {
				const response = await fetch(
					`${SERVER_BASE_URL}/api/navbar`,
					{
						method: "POST",

						headers: {
							"Content-Type": "application/json",
						},

						body: JSON.stringify({
							brand: "Azure",
						}),

						signal: controller.signal,
					}
				);

				if (!response.ok) {
					throw new Error(
						`Navbar API error: ${response.status}`
					);
				}

				const result =
					await response.json();

				console.log(
					"AZURE NAVBAR API:",
					result
				);

				/* =============================================
				   TRANSFORM API CATEGORIES

				   Prom    => PROM
				   Bridal  => BRIDAL
				   Evening => EVENING
				============================================= */

				if (
					result?.data &&
					typeof result.data === "object"
				) {
					const transformedData = {};

					Object.entries(
						result.data
					).forEach(
						([
							categoryName,
							categoryValue,
						]) => {
							const key =
								String(
									categoryName
								).toUpperCase();

							const years =
								Array.isArray(
									categoryValue?.years
								)
									? categoryValue.years
									: [];

							transformedData[key] = {
								years,
							};
						}
					);

					/* Keep defaults if an API category is missing */

					setApiData({
						...defaultData,
						...transformedData,
					});
				} else {
					setApiData(
						defaultData
					);
				}
			} catch (error) {
				if (
					error.name ===
					"AbortError"
				) {
					return;
				}

				console.error(
					"Error fetching Azure navbar:",
					error
				);

				setApiData(
					defaultData
				);
			}
		};

		fetchNavbarData();

		return () => {
			controller.abort();
		};
	}, []);

	/* =====================================================
	   SCROLL
	===================================================== */

	useEffect(() => {
		const handleScroll = () => {
			setIsScrolled(
				window.scrollY > 50
			);
		};

		window.addEventListener(
			"scroll",
			handleScroll
		);

		return () => {
			window.removeEventListener(
				"scroll",
				handleScroll
			);
		};
	}, []);

	/* =====================================================
	   GENERATE CATEGORY OPTIONS
	===================================================== */

	const generateCategoryOptions = (
		categoryName
	) => {
		const categoryKey =
			String(
				categoryName
			).toUpperCase();

		const category =
			apiData[categoryKey];

		if (!category) {
			return [];
		}

		const years =
			Array.isArray(
				category.years
			)
				? [...category.years]
				: [];

		/* Newest first */

		years.sort(
			(a, b) =>
				Number(b) -
				Number(a)
		);

		const routeCategory =
			categoryKey.toLowerCase();

		/* Collection options */

		const options = years.map(
			(year) => ({
				label: `${year} Collection`,

				value: `/${routeCategory}/${year}`,
			})
		);

		/* =============================================
		   SIZE CHART

		   PROM
		   /size-chart/prom

		   BRIDAL
		   /size-chart/bridal

		   EVENING
		   /size-chart/evening
		============================================= */

		options.push({
			label: "Size Chart",

			value: `/size-chart/${routeCategory}`,
		});

		return options;
	};

	/* =====================================================
	   OPTIONS
	===================================================== */

	const promOptions =
		generateCategoryOptions("PROM");

	const bridalOptions =
		generateCategoryOptions("BRIDAL");

	const eveningOptions =
		generateCategoryOptions("EVENING");

	/* =====================================================
	   JSX
	===================================================== */

	return (
		<>
			{/* =================================================
			    NAVBAR
			================================================= */}

			<div
				className={`fixed left-0 w-full z-50 transition-all duration-500 ${
					isScrolled
						? "top-[-52px]"
						: "top-0"
				}`}
			>
				{/* =============================================
				    TOP BLUE BAR
				============================================= */}

				<div
					className={`flex md:justify-between justify-center items-center bg-[#1f4c94] w-full px-5 py-3 transition-all duration-500 ${
						isScrolled
							? "opacity-0 pointer-events-none -translate-y-4 scale-95"
							: "opacity-100 translate-y-0 scale-100"
					}`}
				>
					{/* Instagram */}

					<Link
						to="https://www.instagram.com/azuredress?igsh=MXhoNzZ2N3hqbjgyeA=="
						target="_blank"
					>
						<Icon
							icon="ri:instagram-fill"
							width="22"
							height="22"
							className="text-white hover:text-gray-300 transition"
						/>
					</Link>

					{/* Search */}

					<div className="hidden md:flex items-center gap-3">
						<button
							type="button"
							onClick={() =>
								setShowSearch(
									true
								)
							}
						>
							<Icon
								icon="bx:search-alt"
								width="24"
								height="24"
								color="white"
							/>
						</button>
					</div>
				</div>

				{/* =============================================
				    MAIN NAVIGATION
				============================================= */}

				<div
					className={`bg-white transition-all duration-500 ease-in-out border-b border-gray-100 ${
						isScrolled
							? "shadow-lg py-5"
							: "py-6"
					}`}
				>
					{/* Logo / Mobile */}

					<div className="flex md:justify-center justify-between items-center px-4">

						{/* Mobile Menu */}

						<div
							className="block md:hidden cursor-pointer"
							onClick={() =>
								setShowMenu(
									true
								)
							}
						>
							<Icon
								icon="hugeicons:menu-09"
								width="35"
								height="35"
							/>
						</div>

						{/* AZURE BRAND */}

						<div
							className="cursor-pointer font-americana font-extrabold text-center"
							onClick={() =>
								navigate("/")
							}
						>
							<h2 className="text-4xl bg-gradient-to-r from-[#3A7BD5] via-[#8A2BE2] to-[#00D2FF] bg-clip-text text-transparent">
								Azure
							</h2>

							<span className="text-[10px] uppercase tracking-[3px] text-gray-600 mt-2 block">
								Proudly Canadian
							</span>
						</div>

						{/* Mobile Search */}

						<div className="flex items-center gap-3 md:hidden">
							<button
								type="button"
								onClick={() =>
									setShowSearch(
										true
									)
								}
							>
								<Icon
									icon="bx:search-alt"
									width="24"
									height="24"
									color="black"
								/>
							</button>
						</div>
					</div>

					{/* =========================================
					    DESKTOP MENU
					========================================= */}

					<div className="pt-3 pb-3 hidden md:block">

						<ul className="hidden md:flex font-poppins justify-center items-center gap-8 flex-wrap">

							{/* HOME */}

							<li>
								<Link
									to="/"
									className="text-black font-medium hover:text-[#1f4c94] py-2 px-3"
								>
									HOME
								</Link>
							</li>

							{/* =====================================
							    PROM
							===================================== */}

							{promOptions.length >
								0 && (
								<DropdownMenu
									title="PROM"
									options={
										promOptions
									}
								/>
							)}

							{/* =====================================
							    BRIDAL
							===================================== */}

							{bridalOptions.length >
								0 && (
								<DropdownMenu
									title="BRIDAL"
									options={
										bridalOptions
									}
								/>
							)}

							{/* =====================================
							    EVENING
							===================================== */}

							{eveningOptions.length >
								0 && (
								<DropdownMenu
									title="EVENING"
									options={
										eveningOptions
									}
								/>
							)}

							{/* ABOUT */}

							<li>
								<Link
									to="/about"
									className="text-black font-medium hover:text-[#1f4c94] py-2 px-3"
								>
									ABOUT US
								</Link>
							</li>

							{/* CONTACT */}

							<li>
								<Link
									to="/contact"
									className="text-black font-medium hover:text-[#1f4c94] py-2 px-3"
								>
									CONTACT
								</Link>
							</li>

							{/* RETAILER LOGIN */}

							<li className="border-[2px] border-[#1f4c94] p-2 rounded-md text-[#1f4c94] hover:bg-[#1f4c94] hover:text-white transition">

								<a
									href="https://market.azuredress.com/"
									target="_blank"
									rel="noopener noreferrer"
									className="flex items-center gap-1 transition"
								>
									<span className="text-sm font-semibold">
										RETAILER LOGIN
									</span>
								</a>

							</li>
						</ul>
					</div>
				</div>
			</div>

			{/* =================================================
			    SEARCH MODAL
			================================================= */}

			<SearchModal
				show={showSearch}
				onClose={() =>
					setShowSearch(
						false
					)
				}
				data={data}
			/>

			{/* =================================================
			    MOBILE MENU
			================================================= */}

			<MenuModal
				show={showMenu}
				onClose={() =>
					setShowMenu(
						false
					)
				}
				apiData={apiData}
			/>
		</>
	);
}

/* =========================================================
   SEARCH MODAL
========================================================= */

function SearchModal({
	show,
	onClose,
	data,
}) {
	const [searchTerm, setSearchTerm] =
		useState("");

	const filteredResults =
		searchTerm?.length >= 3
			? data?.filter((item) =>
					item.style
						?.toLowerCase()
						?.includes(
							searchTerm.toLowerCase()
						)
			  )
			: [];

	return (
		<div
			className={`fixed inset-0 bg-white z-[1000] flex flex-col items-center justify-start pt-20 transition-all duration-500 ease-in-out ${
				show
					? "opacity-100 visible"
					: "opacity-0 invisible"
			}`}
		>

			{/* CLOSE */}

			<div className="absolute top-6 right-6">
				<button
					type="button"
					onClick={onClose}
					className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition"
				>
					<Icon
						icon="system-uicons:cross"
						width="35"
						height="35"
						color="#000"
					/>
				</button>
			</div>

			{/* SEARCH */}

			{data?.length > 0 ? (
				<div className="w-[90%] md:w-[60%] lg:w-[40%] flex items-center gap-3 border-b-2 border-gray-400 pb-2 mb-6">

					<Icon
						icon="bx:search-alt"
						width="30"
						height="30"
						color="black"
					/>

					<input
						type="text"
						value={
							searchTerm
						}
						onChange={(e) =>
							setSearchTerm(
								e.target.value
							)
						}
						placeholder="Search here..."
						className="w-full outline-none text-lg font-medium"
					/>

				</div>
			) : (
				<p className="text-gray-500">
					Loading...
				</p>
			)}

			{/* RESULTS */}

			<div
				style={{
					scrollbarWidth:
						"thin",

					scrollbarColor:
						"#1f4c94",
				}}
				className="w-[90%] md:w-[70%] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 overflow-y-auto max-h-[80vh] pb-10"
			>
				{filteredResults.length >
				0 ? (
					filteredResults.map(
						(item) => (
							<Featurelist
								key={
									item?._id ||
									item?.id ||
									item?.style
								}
								data={item}
							/>
						)
					)
				) : searchTerm.length >=
				  3 ? (
					<p className="text-gray-500 text-center w-full">
						No results found.
					</p>
				) : (
					<p className="text-gray-400 text-center w-full">
						Type at least 3 letters to search
					</p>
				)}
			</div>
		</div>
	);
}

/* =========================================================
   MOBILE MENU
========================================================= */

function MenuModal({
	show,
	onClose,
	apiData,
}) {
	const [openDropdown, setOpenDropdown] =
		useState(null);

	const toggleDropdown = (
		menuName
	) => {
		setOpenDropdown(
			openDropdown ===
				menuName
				? null
				: menuName
		);
	};

	return (
		<>
			{/* OVERLAY */}

			{show && (
				<div
					className="fixed inset-0 bg-black/40 z-[999]"
					onClick={onClose}
				/>
			)}

			{/* MENU */}

			<div
				className={`fixed top-0 left-0 h-full w-[80%] md:w-[40%] bg-white shadow-2xl z-[1000] transition-transform duration-500 ease-in-out overflow-y-auto ${
					show
						? "translate-x-0"
						: "-translate-x-full"
				}`}
			>

				{/* HEADER */}

				<div className="flex justify-between items-center px-5 py-4 border-b">

					<div>
						<h2 className="text-2xl font-bold text-[#1f4c94]">
							Azure
						</h2>

						<span className="text-[9px] uppercase tracking-[2px] text-gray-500">
							Proudly Canadian
						</span>
					</div>

					<button
						type="button"
						onClick={onClose}
						className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition"
					>
						<Icon
							icon="si:close-duotone"
							width="35"
							height="35"
							color="#000"
						/>
					</button>
				</div>

				{/* NAVIGATION */}

				<ul className="flex flex-col gap-4 mt-5 px-4 font-poppins text-[16px] font-medium text-black">

					{/* HOME */}

					<li className="px-2">
						<Link
							to="/"
							onClick={
								onClose
							}
						>
							HOME
						</Link>
					</li>

					{/* =========================================
					    DYNAMIC CATEGORIES
					========================================= */}

					{Object.keys(
						apiData
					).map(
						(categoryName) => {
							const categoryKey =
								categoryName.toLowerCase();

							const years =
								Array.isArray(
									apiData[
										categoryName
									]?.years
								)
									? [
											...apiData[
												categoryName
											].years,
									  ].sort(
											(
												a,
												b
											) =>
												Number(
													b
												) -
												Number(
													a
												)
									  )
									: [];

							return (
								<li
									className="px-2"
									key={
										categoryName
									}
								>
									<button
										type="button"
										onClick={() =>
											toggleDropdown(
												categoryKey
											)
										}
										className="flex items-center gap-2 font-medium hover:text-[#1f4c94] w-full text-left"
									>
										{
											categoryName
										}

										<Icon
											icon={
												openDropdown ===
												categoryKey
													? "akar-icons:chevron-up"
													: "akar-icons:chevron-down"
											}
										/>
									</button>

									{openDropdown ===
										categoryKey && (
										<ul className="ml-5 mt-2 flex flex-col gap-4">

											{/* COLLECTION YEARS */}

											{years.map(
												(
													year
												) => (
													<li
														key={
															year
														}
														className="hover:text-[#1f4c94] text-black"
													>
														<Link
															to={`/${categoryKey}/${year}`}
															onClick={
																onClose
															}
														>
															{
																year
															}{" "}
															Collection
														</Link>
													</li>
												)
											)}

											{/* =================================
											    SIZE CHART

											    No popup.

											    Direct page:
											    /size-chart/prom
											    /size-chart/bridal
											    /size-chart/evening
											================================= */}

											<li className="hover:text-[#1f4c94] text-black">

												<Link
													to={`/size-chart/${categoryKey}`}
													onClick={
														onClose
													}
													className="w-full block text-left hover:text-[#1f4c94]"
												>
													Size Chart
												</Link>

											</li>
										</ul>
									)}
								</li>
							);
						}
					)}

					{/* ABOUT */}

					<li className="px-2">
						<Link
							to="/about"
							onClick={
								onClose
							}
						>
							ABOUT US
						</Link>
					</li>

					{/* CONTACT */}

					<li className="px-2">
						<Link
							to="/contact"
							onClick={
								onClose
							}
						>
							CONTACT
						</Link>
					</li>

					{/* RETAILER */}

					<li>
						<a
							href="https://market.azuredress.com/"
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-1 bg-[#1f4c94] text-white px-2 py-3 hover:text-gray-300 transition"
							onClick={
								onClose
							}
						>
							<span className="font-medium">
								RETAILER LOGIN
							</span>
						</a>
					</li>
				</ul>
			</div>
		</>
	);
}